// extracted by mini-css-extract-plugin
export default {"error":"ExpenseModal_error__cvxhV"};